import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { GuestIdResolver } from './resolvers/guest-id.resolver';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./views/views.module').then(m => m.ViewsModule),
    resolve: {
      id: GuestIdResolver,
    },
  },
  {
    path: '**',
    redirectTo: '404',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
